




























import {Component, Vue} from "vue-property-decorator";
import myTitle from "./components/myTitle.vue";

@Component({
  components: {
    myTitle
  },
})

export default class businessScreen extends Vue{

  // 用于表示 鼠标悬浮的企业痛点下标
  hoverIndex = -1;

  path = 'assets/solution/businessScreen/';

  cardContent = [
    {
      src: this.path + 'xiaolv.png',
      title: '服务团队效率低',
      text: '商用显示设备脆弱易受损，是企业的门面招牌，若不能及时处理将会导致企业的业务无法正常进行，同时影响企业的对外宣传和企业形象等问题',
      active: this.path + 'xiaolv1.png'
    },
    {
      src: this.path + 'baoxiu.png',
      title: '报修渠道太单一',
      text: '传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差',
      active: this.path + 'baoxiu1.png',
    },
    {
      src: this.path + 'beijian.png',
      title: '备件管理不科学',
      text: '没有制定科学的备件管理计划，导致需要维修时备件缺货，临时调度成本高且影响设备维修进度',
      active: this.path + 'beijian1.png',
    },
    {
      src: this.path + 'weihu.png',
      title: '维护历史难追溯',
      text: '设备维护的历史情况没有备案或者很难查询，管理方式不科学、不合理',
      active: this.path + 'weihu1.png'
    },
    {
      src: this.path + 'jindu.png',
      title: '服务进度不明确',
      text: '服务状况难以跟进，服务商没有成熟的管理系统，不清楚售后服务是否按企业要求的标准进行，容易与客户产生争议，影响企业口碑',
      active: this.path + 'jindu1.png',
    },
    {
      src: this.path + 'jixiao.png',
      title: '绩效考核不到位',
      text: '企业对服务人员的满意度无法清晰反馈，服务商不能做针对性改进，用户体验难以提高',
      active: this.path + 'jixiao1.png',
    },
  ];
  solutions = [
    {
      title:'服务网络遍布全国',text:'全国有350+服务站点，拥有约2000人的自有专业服务团队，服务人员兢兢业业，服务质量值得信赖，服务范围覆盖全国'
    },
    {
      title:'售后进度实时跟踪',text:'平台将实时更新工单情况，消息可通过短信、手机app、微信等多种方式通知用户，让您全程掌握售后信息，轻松进行售后管理'
    },
    {
      title:'科学化备件管理',text:'平台提供备件管理功能，让用户准确跟踪每一个备件的动向，通过对备件使用情况的多维度分析，制定出科学的备件管理计划'
    },
    {
      title:'完善的绩效考核机制',text:'用户可对服务人员的满意度进行评价，评价结果将会对服务人员的绩效产生影响，用量化满意度的方式促进平台进步，从而更好地满足用户需求'
    },
  ];
}
